import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "card-title mt-0" }
const _hoisted_4 = { class: "row download-data-histories-list" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { colspan: "9" }

import { onMounted, ref } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';
import getDownloadData from '@/types/responses/getDownloadData';
import Row from '@/components/DownloadDataHistoriesParts/DataRow.vue';
import { formatDate } from '@/services/functions';
import i18n from '@/lang/i18n';
import { getAccessCheckerInstance } from '@/router/accessChecker';
import { routingAuthorityNames } from '@/services/consts';


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadDataHistories',
  setup(__props) {

const title = i18n.global.t('pages.downloadData.title.downloadDataHistories')
const downloadDataHistoryItems = ref<getDownloadData[]>([]);

onMounted(() => {
  document.title = title
  getHistories();
});

function makeGetRequestParams() {
  let today = new Date();
  today.setMonth(today.getMonth() - 3);
  const params = {
    start: formatDate(today),
  };
  return params;
}

async function getHistories(){
  const params = makeGetRequestParams();
  const accessChecker = await getAccessCheckerInstance();
  const hasDownloadData = accessChecker.hasUserAccessTo(routingAuthorityNames.DownloadDataHistories);
  const hasCsvDataExport = accessChecker.hasUserAccessTo(routingAuthorityNames.CsvDataExport);

  const requests: Promise<getDownloadData[]>[] = [];
  if (hasDownloadData) {
    requests.push(Api().getDownloadDatas(params));
  }
  if (hasCsvDataExport) {
    requests.push(Api().getCsvDataExports(params));
  }

  const results = await Promise.all(requests);
  downloadDataHistoryItems.value = results.flat().sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(title)), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_table, null, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.downloadData.outputDate')), 1),
                _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.downloadData.status')), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.downloadData.user')), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.downloadData.format')), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.downloadData.fileName')), 1),
                _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.downloadData.fileFormat')), 1),
                _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (downloadDataHistoryItems.value?.length != 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(downloadDataHistoryItems.value, (item) => {
                    return (_openBlock(), _createBlock(Row, {
                      key: item.id,
                      item: item
                    }, null, 8, ["item"]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(i18n).global.t('pages.downloadData.messages.noData')), 1)
                  ]))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})